function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.87 5.107h1.884v1.886H8.87V5.107z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 1.904c-4.473 0-8.099 3.633-8.099 8.114 0 4.48 3.626 8.113 8.099 8.113 4.473 0 8.099-3.633 8.099-8.114 0-4.48-3.626-8.113-8.099-8.113zM0 10.018C0 4.484 4.477 0 10 0s10 4.485 10 10.018c0 5.532-4.477 10.017-10 10.017S0 15.55 0 10.017z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.295 8.31H10l.95.952v4.336h.754v1.904H10l-.951-.952v-4.336h-.754V8.31z",
  fill: "#fff"
});

function SvgInfoToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgInfoToast;